import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="font-sans text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <Benefits data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Author data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <PurchaseNotification data-id="element-12" />
    </div>;
}